import { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Link,
  useOutletContext,
} from "react-router-dom";
import { WishlistProvider } from "./context/WishlistContext";
import { CartProvider, useCart } from "./context/CartContext";
import { ProductProvider } from "./context/ProductContext";
import Navbar from "./components/Navbar";
import BottomNav from "./components/BottomNav";
import MiniCartSidebar from "./components/MiniCartSidebar";
import InstallPWA from "./components/InstallPWA";
import OfflineIndicator from "./components/OfflineIndicator";
import Home from "./pages/Home";
import ProductDetail from "./pages/ProductDetail";
import CategoryPage from "./pages/CategoryPage";
import CategoriesPage from "./pages/CategoriesPage";
import AllProductsPage from "./pages/AllProductsPage";
import WishlistPage from "./pages/WishlistPage";
import CartPage from "./pages/CartPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import AccountPage from "./pages/AccountPage";
import AdminPage from "./pages/AdminPage";

function CustomerLayout() {
  const [searchTerm, setSearchTerm] = useState("");
  const { cart } = useCart();
  const hasCartItems = cart.length > 0;

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  return (
    <div className={`App ${hasCartItems ? "md:pr-64" : ""}`}>
      <Navbar onSearch={setSearchTerm} onClearSearch={handleClearSearch} />
      <MiniCartSidebar />
      <OfflineIndicator />
      <Outlet context={{ searchTerm, handleClearSearch }} />
      <BottomNav />
      <InstallPWA />
      <footer className="bg-gray-800 text-white py-8 mt-12 mb-16 md:mb-0">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8 mb-6">
            <div>
              <div className="mb-4">
                <img
                  src="/logo.png"
                  alt="UyirUdalFoods"
                  className="h-16 object-contain"
                />
              </div>
              <p className="text-gray-400 text-sm">
                Your favorite snacks, delivered fresh!
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/about"
                    className="text-gray-400 hover:text-white transition text-sm"
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-gray-400 hover:text-white transition text-sm"
                  >
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/categories"
                    className="text-gray-400 hover:text-white transition text-sm"
                  >
                    Categories
                  </Link>
                </li>
                <li>
                  <Link
                    to="/products"
                    className="text-gray-400 hover:text-white transition text-sm"
                  >
                    All Products
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Contact</h4>
              <p className="text-gray-400 text-sm mb-2">📞 +91 98404 53354</p>
              <p className="text-gray-400 text-sm">📧 info@uyirudalfoods.com</p>
            </div>
          </div>
          <div className="border-t border-gray-700 pt-6 text-center">
            <p className="text-gray-400 text-sm">
              © 2024 UyirUdalFoods. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

function HomeWrapper() {
  const { searchTerm, handleClearSearch } = useOutletContext();
  return <Home searchTerm={searchTerm} onClearSearch={handleClearSearch} />;
}

function App() {
  return (
    <ProductProvider>
      <CartProvider>
        <WishlistProvider>
          <Router>
            <Routes>
              {/* Admin routes - no customer nav */}
              <Route path="/admin/*" element={<AdminPage />} />

              {/* Customer routes - with nav/footer */}
              <Route element={<CustomerLayout />}>
                <Route path="/" element={<HomeWrapper />} />
                <Route path="/products" element={<AllProductsPage />} />
                <Route path="/categories" element={<CategoriesPage />} />
                <Route path="/wishlist" element={<WishlistPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route
                  path="/category/:categoryId"
                  element={<CategoryPage />}
                />
              </Route>
            </Routes>
          </Router>
        </WishlistProvider>
      </CartProvider>
    </ProductProvider>
  );
}

export default App;
